import { render } from "./JobSeekerList.vue?vue&type=template&id=8395cbe2&scoped=true&ts=true"
import script from "./JobSeekerList.vue?vue&type=script&lang=ts"
export * from "./JobSeekerList.vue?vue&type=script&lang=ts"

import "./JobSeekerList.vue?vue&type=style&index=0&id=8395cbe2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8395cbe2"]])

export default __exports__